import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-logo',
  templateUrl: './mobile-logo.component.html',
  styleUrls: ['./mobile-logo.component.css']
})
export class MobileLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
